export default __webpack_public_path__ + "static/media/landing-image.e60ba9b5.png";